import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastProvider } from './contexts/ToastContext';
import Navbar from './components/Navbar';
import MaintenanceMode from './components/MaintenanceMode';
import Home from './pages/Home';
import Scripts from './pages/Scripts';
import Documentation from './pages/Documentation';
import Partners from './pages/Partners';
import Panel from './pages/Panel';
import './App.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function App() {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const isFirstLoad = useRef(true);

  useEffect(() => {
    checkMaintenanceStatus();
    
    // Check maintenance status every 30 seconds
    const interval = setInterval(checkMaintenanceStatus, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const checkMaintenanceStatus = async () => {
    try {
      const response = await fetch(`${API_URL}/api/maintenance`, {
        credentials: 'include'
      });
      const data = await response.json();
      
      // Only reload if maintenance mode changes after initial load
      if (!isFirstLoad.current && !maintenanceMode && data.maintenanceMode && !data.hasAccess) {
        window.location.reload();
        return;
      }
      
      // Only update state if values actually changed
      if (data.maintenanceMode !== maintenanceMode) {
        setMaintenanceMode(data.maintenanceMode);
      }
      if (data.hasAccess !== hasAccess) {
        setHasAccess(data.hasAccess);
      }
      
      // Mark that first load is complete
      if (isFirstLoad.current) {
        isFirstLoad.current = false;
      }
    } catch (error) {
      console.error('Error checking maintenance status:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return null; // or a loading spinner
  }

  // Show maintenance mode for users without access - as full page, not overlay
  if (maintenanceMode && !hasAccess) {
    return (
      <div className="App">
        <MaintenanceMode />
      </div>
    );
  }

  return (
    <ToastProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/panel/*" element={<Panel />} />
            <Route
                path="/*"
                element={
                  <>
                    <Navbar />
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/scripts" element={<Scripts />} />
                      <Route path="/partners" element={<Partners />} />
                      <Route path="/documentation" element={<Documentation />} />
                    </Routes>
                  </>
                }
              />
            </Routes>
          </div>
        </Router>
      </ToastProvider>
    );
}

export default App;
